import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  const stats = [{
    number: '100+',
    label: 'Empresas creadas'
  }, {
    number: '100%',
    label: 'En español'
  }, {
    number: '< 2 sem',
    label: 'Tiempo promedio'
  }];
  return <section style={{
    background: '#FAFAFA',
    padding: '100px 24px'
  }} data-id="element-68">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="relative overflow-hidden mx-auto" style={{
      background: 'linear-gradient(135deg, #4a3666 0%, #5a4579 50%, #8B6BA8 100%)',
      borderRadius: '32px',
      padding: '80px 24px',
      maxWidth: '960px',
      boxShadow: '0 40px 100px rgba(90,69,121,0.3)'
    }} data-id="element-69">
        {/* Decorative orbs */}
        <div className="absolute pointer-events-none" style={{
        top: '-80px',
        right: '-80px',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.06)'
      }} aria-hidden="true" data-id="element-70" />
        <div className="absolute pointer-events-none" style={{
        bottom: '-60px',
        left: '-60px',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.04)'
      }} aria-hidden="true" data-id="element-71" />

        {/* Decorative dot grid */}
        <div className="absolute pointer-events-none hidden md:block" style={{
        right: '60px',
        top: '60px',
        opacity: 0.1,
        width: '120px',
        height: '120px',
        backgroundImage: 'radial-gradient(circle, #FFFFFF 1.5px, transparent 1.5px)',
        backgroundSize: '24px 24px'
      }} aria-hidden="true" data-id="element-72" />

        <div className="relative mx-auto text-center px-2 md:px-12" style={{
        maxWidth: '720px'
      }} data-id="element-73">
          {/* Label */}
          <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          textAlign: 'center'
        }} data-id="element-74">
            Da el siguiente paso
          </p>

          {/* Title */}
          <h2 className="text-[32px] md:text-[44px]" style={{
          color: '#FFFFFF',
          fontWeight: 900,
          textAlign: 'center',
          lineHeight: 1.2,
          marginTop: '8px',
          letterSpacing: '-0.02em'
        }} data-id="element-75">
            ¿Listo(a) para lanzar tu negocio en serio?
          </h2>

          {/* Subtitle */}
          <p className="mx-auto" style={{
          color: 'rgba(255,255,255,0.75)',
          fontSize: '18px',
          textAlign: 'center',
          maxWidth: '480px',
          margin: '16px auto 48px',
          lineHeight: 1.6
        }} data-id="element-76">
            Más de 50 emprendedores latinos ya formalizaron su negocio con
            Inkova. Tú puedes ser el próximo.
          </p>

          {/* Stats */}
          <div className="flex justify-center flex-wrap" style={{
          gap: '60px',
          marginBottom: '48px',
          paddingBottom: '48px',
          borderBottom: '1px solid rgba(255,255,255,0.15)'
        }} data-id="element-77">
            {stats.map((s, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15 + i * 0.08
          }} style={{
            textAlign: 'center'
          }} data-id="element-78">
                <div style={{
              fontSize: '40px',
              fontWeight: 900,
              color: '#FFFFFF',
              lineHeight: 1
            }} data-id="element-79">
                  {s.number}
                </div>
                <div style={{
              fontSize: '13px',
              color: 'rgba(255,255,255,0.6)',
              marginTop: '6px'
            }} data-id="element-80">
                  {s.label}
                </div>
              </motion.div>)}
          </div>

          {/* CTAs */}
          <div className="flex justify-center flex-wrap" style={{
          gap: '16px'
        }} data-id="element-81">
            <a href="#planes" className="group inline-flex items-center gap-2 transition-all duration-300" style={{
            background: '#FFFFFF',
            color: '#5a4579',
            borderRadius: '14px',
            padding: '18px 48px',
            fontSize: '16px',
            fontWeight: 800,
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
          }} onMouseEnter={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
          }} onMouseLeave={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
          }} data-id="element-82">
              <span data-id="element-83">Quiero empezar hoy</span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-84" />
            </a>

            <a href="https://wa.me/17863037695?text=Hola%2C%20tengo%20preguntas%20sobre%20Inkova%20y%20quiero%20escribir%20primero" target="_blank" rel="noopener noreferrer" className="inline-flex items-center transition-all duration-300" style={{
            background: 'transparent',
            border: '2px solid rgba(255,255,255,0.4)',
            color: '#FFFFFF',
            borderRadius: '14px',
            padding: '18px 32px',
            fontSize: '15px',
            fontWeight: 600
          }} onMouseEnter={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.borderColor = '#FFFFFF';
          }} onMouseLeave={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.4)';
          }} data-id="element-85">
              Tengo preguntas, escribir primero
            </a>
          </div>

          {/* Guarantee */}
          <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: '12px',
          textAlign: 'center',
          marginTop: '24px'
        }} data-id="element-86">
            Sin compromiso · Primera consulta sin costo · Todo en español
          </p>
        </div>
      </motion.div>
    </section>;
}